import { hasPermission } from "@/lib/permissionUtil";
import { ScheduleType } from "@/containers/schedule/types";

// 根據權限過濾可view create update的公告, permissionIndex = 0: view, 1: create, 2: update, 3: delete
export function getActionDepartmentArray(departmentArray: any, permissionIndex: number) {
  const dataArray: any = [];
  departmentArray.forEach((item: any) => {
    const { permissionIds } = item;
    const permission = permissionIds?.[permissionIndex] ?? 0;
    hasPermission(permission) && dataArray.push(item);
  });
  return dataArray;
}

export function filterScheduleArrayByTarget(scheduleArray: ScheduleType[] = [], roleId: number = 0) {
  const filterScheduleArray = scheduleArray.filter((item: ScheduleType) => (
    roleId === 2 // roleId:2 為學生
      ? item.personType === 0 || item.personType === 1 // 公告對象: 全部與學生
      : item.personType === 0 || item.personType === 1 || item.personType === 2 // 公告對象: 全部 學生 教師
  ));
  return filterScheduleArray;
}